import React from 'react';
import {useTranslation} from "react-i18next";
import CacheData from "./utils/cacheData";

export function TestPage() {

    const { t, i18n } = useTranslation();

    return <div>
        <h1>Test page</h1>
        <h2>Language detection</h2>
        <div>
            <strong>current language: </strong>
            <span>{i18n.language}</span>
        </div>
        <div>
            <strong>browser languages: </strong>
            <span>{ window.navigator.languages.join() }</span>
        </div>
        <div>
            <strong>language manually selected: </strong>
            <span>{ String(CacheData.fetchCache('language_manual') ?? 'false') }</span>
        </div>
    </div>

}
